import React from "react";
import { Link } from "react-router-dom";
import Footer from "./Footer";

export const PolicyLayout = ({ title, updated, children, wide }) => (
  <div className="min-h-screen flex flex-col bg-gradient-to-b from-green-50 to-white">
    <header className="bg-green-900 text-white">
      <div className="max-w-4xl mx-auto px-6 pt-6 pb-16">
        <Link to="/" className="text-sm text-yellow-300 hover:text-yellow-200">
          ← Back to Home
        </Link>
        <h1 className="mt-6 text-3xl md:text-5xl font-black leading-tight">
          {title}
        </h1>
        {updated && (
          <p className="mt-3 inline-block text-xs font-semibold bg-yellow-300 text-green-950 rounded-full px-3 py-1">
            Last Updated: {updated}
          </p>
        )}
      </div>
    </header>

    <main className="flex-1 w-full max-w-4xl mx-auto px-4 -mt-10 mb-12">
      <div className="bg-white rounded-3xl shadow-xl border border-green-100 p-6 md:p-10 text-gray-700 leading-relaxed space-y-4">
        {children}
      </div>
    </main>
    <Footer />
  </div>
);

export const H2 = ({ children }) => (
  <h2 className="text-xl md:text-2xl font-extrabold text-green-900 pt-4 border-l-4 border-yellow-400 pl-3">
    {children}
  </h2>
);
